import { AlertTriangle, XCircle } from "lucide-react";
import type { Warning, AssistantError } from "@/lib/api/assistant";

export function WarningsPanel({ warnings }: { warnings: Warning[] }) {
  if (warnings.length === 0) return null;
  return (
    <div className="border border-amber-200 bg-amber-50 rounded-lg overflow-hidden">
      <div className="px-4 py-2 flex items-center gap-2 text-sm font-medium text-amber-900 border-b border-amber-200">
        <AlertTriangle className="h-4 w-4" />
        Warnings
        <span className="text-xs text-amber-700">({warnings.length})</span>
      </div>
      <div className="divide-y divide-amber-100">
        {warnings.map((w, i) => (
          <div key={i} className="px-4 py-2 text-sm text-amber-900">
            <div>{w.message}</div>
            <div className="text-[11px] text-amber-700 mt-0.5 font-mono">
              {w.code}
              {w.field_path ? ` · ${w.field_path}` : ""}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function ErrorsPanel({ errors }: { errors: AssistantError[] }) {
  if (errors.length === 0) return null;
  return (
    <div className="border border-rose-200 bg-rose-50 rounded-lg overflow-hidden">
      <div className="px-4 py-2 flex items-center gap-2 text-sm font-medium text-rose-900 border-b border-rose-200">
        <XCircle className="h-4 w-4" />
        Errors
        <span className="text-xs text-rose-700">({errors.length})</span>
      </div>
      <div className="divide-y divide-rose-100">
        {errors.map((e, i) => (
          <div key={i} className="px-4 py-2 text-sm text-rose-900">
            <div className="flex items-center gap-2">
              {e.fatal && (
                <span className="text-[10px] uppercase font-semibold px-1.5 py-0.5 rounded border border-rose-300 bg-white text-rose-700">
                  fatal
                </span>
              )}
              <span>{e.message}</span>
            </div>
            <div className="text-[11px] text-rose-700 mt-0.5 font-mono">
              {e.code}
              {e.field_path ? ` · ${e.field_path}` : ""}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
